import { Box } from '@mui/material'

export const NotFound = ()=>{

    return(
        <Box sx={{
            textAlign:'center'
        }}>
            NotFound
        </Box>
    )
}